import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { getAllCartera } from '../../../features/cartera-asignada/apiCartera';

export const fetchCartera = createAsyncThunk(
  'cartera/fetchCartera',
  async (
    { page = 1, manager = '', name = '', phone = '', proscai_id = '', store = '', sort_by = '', sort_order = '' },
    thunkAPI
  ) => {
    try {
      // Usaremos URLSearchParams para construir la URL de manera más limpia
      const params = new URLSearchParams();

      params.append('page', page);
      if (manager) params.append('manager', manager);
      if (name) params.append('name', name);
      if (phone) params.append('phone', phone);
      if (proscai_id) params.append('proscai_id', proscai_id);
      if (store) params.append('store', store);

      // --- Nuevos parámetros para ordenamiento ---
      if (sort_by) {
        // Aquí es donde podrías mapear el 'value' de tu columna (ej. 'Nombre')
        // a un nombre de campo que tu backend realmente espera (ej. 'full_name').
        // Si tu backend ya espera exactamente el 'value' que estás enviando,
        // entonces no necesitas un mapeo.
        // Ejemplo de mapeo si es necesario:
        const apiSortField =
          {
            Nombre: 'full_name',
            'Proscai ID': 'proscai_id',
            Tienda: 'store',
            Cadena: 'cadena',
            'Saldo Vencido': 'balance_due',
            Mora: 'arrears',
            'Saldo Total': 'total_balance',
            'Días de Atraso': 'expiration_days',
            Gestor: 'manager',
            'Promesa de Pago': 'promise_of_payment',
            // Agrega aquí cualquier otro mapeo necesario
          }[sort_by] || sort_by; // Si no hay mapeo específico, usa el mismo 'sort_by'

        params.append('sort_by', apiSortField);
      }
      if (sort_order) {
        params.append('sort_order', sort_order);
      }
      // ------------------------------------------

      const response = await getAllCartera(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener data');
    }
  }
);

const carteraMirrorSlice = createSlice({
  name: 'cartera',
  initialState: {
    cartera: {
      result: [],
      count: 0,
      next: null,
      previous: null,
    },
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCartera.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCartera.fulfilled, (state, action) => {
        state.loading = false;
        state.cartera = action.payload;
      })
      .addCase(fetchCartera.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default carteraMirrorSlice.reducer;
